module.exports = __webpack_public_path__ + "static/media/defaultimg.c44ec7f4.jpg";